import { render, staticRenderFns } from "./Box16.vue?vue&type=template&id=7f9089ec&scoped=true&"
import script from "./Box16.vue?vue&type=script&lang=js&"
export * from "./Box16.vue?vue&type=script&lang=js&"
import style0 from "./Box16.vue?vue&type=style&index=0&id=7f9089ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9089ec",
  null
  
)

export default component.exports